export default __webpack_public_path__ + "static/resource1-a5a5b6e95d959b1bc1ac752e4aa7653c.png";